export const ROLES = ["admin", "restaurant", "supplier"] as const;
export type Role = (typeof ROLES)[number];

/** open → confirming → confirmed | cancelled → closed (spec §3-1) */
export const ROUND_STATUSES = ["open", "confirming", "confirmed", "cancelled", "closed"] as const;
export type RoundStatus = (typeof ROUND_STATUSES)[number];

/**
 * soft → confirmed → fulfilled (no-show buffer mechanism, spec §3-1)
 * - no_show:     the restaurant did not give final confirmation before the deadline →
 *                this is restaurant-trust data.
 * - undelivered: the supplier failed to supply → this is not the restaurant's fault, so it
 *                must be kept distinct from no_show or the restaurant-trust data is corrupted.
 */
export const COMMITMENT_STATUSES = ["soft", "confirmed", "fulfilled", "no_show", "undelivered"] as const;
export type CommitmentStatus = (typeof COMMITMENT_STATUSES)[number];

export const DEAL_STATUSES = ["open", "closed", "expired"] as const;
export type DealStatus = (typeof DEAL_STATUSES)[number];

/** pending → accepted → fulfilled, or pending → rejected | cancelled. A cart-style direct order — no threshold, no pooling. */
export const ORDER_STATUSES = ["pending", "accepted", "rejected", "cancelled", "fulfilled"] as const;
export type OrderStatus = (typeof ORDER_STATUSES)[number];

export const INVOICE_SOURCE_TYPES = ["group_buy_round", "clearance_deal", "order"] as const;
export type InvoiceSourceType = (typeof INVOICE_SOURCE_TYPES)[number];

export const INVITE_TTL_MS = 7 * 24 * 60 * 60 * 1000;
export const MIN_PASSWORD_LENGTH = 10;
